import React, { useState } from 'react';

const EcoclimaExpert = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Tooltip */}
      {isHovered && (
        <div className="bg-gray-900 text-white text-sm px-4 py-2 rounded-lg shadow-lg max-w-[220px] text-center animate-fade-in">
          Un expert ECOCLIMA vous conseille en ligne
        </div>
      )}

      {/* Button */}
      <a
        href="https://chat.ecoclima.energy/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="ecoclima-expert-btn"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="group flex items-center gap-3 bg-blue-600 hover:bg-blue-700 text-white pl-4 pr-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
      >
        <span className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </span>
        <span className="font-semibold text-sm whitespace-nowrap">ECOCLIMA Expert</span>
      </a>
    </div>
  );
};

export default EcoclimaExpert;
